import { useState, useEffect, useRef } from "react";
import { useNotification } from "../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../Hooks/useApiErrorHandler";
import useTokenRefresh from "../../../Hooks/useTokenRefresh";
import httpclient from "../../../Utils";

export const useRegionalFreight = (options = {}) => {
  const {
    autoFetch = true,
    pagination = { page: 0, pageSize: 20 },
    sorting = [],
    transformData = null,
  } = options;

  const [regionalFreights, setRegionalFreights] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [rowCount, setRowCount] = useState(0);
const [allowAdd, setAllowAdd] = useState(0)
  const prevParams = useRef({
    page: pagination.page,
    pageSize: pagination.pageSize,
    sorting: JSON.stringify(sorting),
  });

  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { getTokenRefreshed: refresh } = useTokenRefresh();

  const fetchRegionalFreights = async (customParams = {}) => {
    const currentParams = {
      page: pagination.page,
      pageSize: pagination.pageSize,
      sorting: JSON.stringify(sorting),
    };

    try {
      setLoading(true);
      setError(null);

      const params = {
        page: pagination.page + 1,
        limit: pagination.pageSize,
        ...customParams,
      };

      if (sorting.length > 0) {
        const sortField = sorting[0].field;
        const sortOrder = sorting[0].sort;
        params.sortBy = sortField;
        params.sortOrder = sortOrder;
      }

      const res = await httpclient.get("/remote-bay-freight-code", { params });
      const { data } = res;
setAllowAdd(data)
      if (data.status === 200) {
        const freights = transformData ? transformData(data.data) : data.data;
        setRegionalFreights(freights);
        setRowCount(data.meta?.total || data.count || 0);

        // Update previous params after successful fetch
        prevParams.current = currentParams;
      } else {
        const errorMsg = data.msg || "Failed to fetch regional freights";
        setError(errorMsg);
        showNotification("error", errorMsg);
      }
    } catch (error) {
      const errorMsg = "Failed to fetch regional freights";
      setError(errorMsg);

      if (error.response?.status === 401) {
        refresh();
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchRegionalFreights();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    autoFetch,
    pagination.page,
    pagination.pageSize,
    JSON.stringify(sorting),
  ]);

  const refreshRegionalFreights = (params = {}) => {
    fetchRegionalFreights(params);
  };

  return {
    regionalFreights,
    setRegionalFreights,
    loading,
    setLoading,
    error,
    rowCount,
    fetchRegionalFreights,
    refresh,
    refreshRegionalFreights,
    allowAdd
  };
};
